import t from 'tcomb';
import Rule from './Rule';

const Validation = t.struct({
  x: t.Any, //t.union[JSON_Value, t.Arr]), //fixme
  rule: t.maybe(Rule)
}, 'Validation');

module.exports = Validation;

/*

function Validation(x, rule) {
  assert(Maybe(Union([JSON_Value, Arr])).is(x));
  assert(Maybe(Rule).is(rule));
  this.x = x;
  this.rule = rule;
  return freeze(this);
}

Validation.is = function(x) {
  return x instanceof Validation;
};

Validation.of = function(x) {
  assert(Obj.is(x));
  return new Validation(
    Maybe(Union([JSON_Value, Arr])).of(x.x),
    Maybe(Rule).of(x.rule)
  );
};

*/


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Validation.js
 **/